module.exports = __webpack_public_path__ + "media/images/png/rent-white/6-1f00c12254cd71ddd179be7df9816ac5.png";